import { MessageBox } from "reusableComponents";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const NumberInput = ({
  label,
  name,
  value,
  min,
  max,
  onChange,
  addonText,
  className = "",
  error,
  disabled = false,
  required = false,
  labelAbove = false, // New boolean prop for label position
  showRequiredText = false, // New prop to toggle required text
}) => {
  const { t } = useTranslation("global");

  return (
    <div
      className={`${styles.wrapper} ${
        labelAbove ? styles.labelAbove : styles.labelInline
      } ${className}`}
    >
      {label && (
        <label className={styles.label}>
          {label}
          {required ? (
            <span
              className={styles.required}
              style={{ fontSize: showRequiredText ? "inherit" : "18px" }}
            >
              {showRequiredText
                ? ` (${t("provide.step2.pictures.required")} *)`
                : `(*)`}
            </span>
          ) : (
            <span className={styles.required}> </span>
          )}
        </label>
      )}
      <div className={styles.inputAndErrContainer}>
        <div className={styles.inputContainer}>
          <input
            type="number"
            name={name}
            min={min}
            max={max}
            // value={disabled ? 0 : value} 
            value ={value} // Always use the value prop
            onChange={onChange}
            disabled={disabled} // Disabled prop added here
            className={`${styles.input} ${error ? styles.errorInput : ""} ${
              disabled ? styles.disabledInput : ""
            }`} // Add disabledInput class when disabled
          />
          {addonText && (
            <span
              className={`${styles.addon} ${
                disabled ? styles.disabledAddon : ""
              }`}
            >
              {addonText}
            </span>
          )}
        </div>
        {error && <MessageBox type="error" message={error} />}
      </div>
    </div>
  );
};

export default NumberInput;
